import { cn } from '@/lib/utils';

interface ErrorBannerProps {
  /** The error message to display. When `null` or `undefined`, nothing is rendered. */
  message: string | null | undefined;
  /** Additional CSS classes. */
  className?: string;
}

/**
 * Inline error banner matching the existing codebase pattern:
 * `bg-error/10 p-4 text-sm text-error`.
 *
 * Renders nothing when `message` is falsy.
 */
export function ErrorBanner({ message, className }: Readonly<ErrorBannerProps>) {
  if (!message) return null;

  return (
    <div
      role="alert"
      className={cn('rounded-md bg-error/10 p-4 text-sm text-error', className)}
    >
      {message}
    </div>
  );
}
